module.exports = __webpack_public_path__ + "static/media/no_image_url_provided.4bb7de0e.png";